import Events from "./module/events";
import Role from "./module/role";
import moment from 'moment';
import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import deLocale from '@fullcalendar/core/locales/de';
import {addDateEventListeners} from './module/calendarEvents';

const events = new Events();

const alpineData = () => {

  moment.locale('de');
  return {
    kursnr: null,
    fromGlobal: null,
    toGlobal: null,
    hasMultipleMonths: null,
    detail: {
      courses: {},
      allCourses: {},
      calendar: null,
      calendar2: null,
      subjects: {},
      size: 5,
      month: '',
      month2: '',
      results: [],
    },

    async initProductCalendar() {

      this.kursnr = document.querySelector('#calendar-course-number').dataset.kursnr;

      const calendarAccordionButton = document.querySelector('.accordion-header-calendar > button');
      const calendarAccordion = document.querySelector('.accordion-header-calendar + div');
      const print_button = document.querySelector('.course__pdf');

      calendarAccordionButton.addEventListener('click', () => {
        if (this.detail.calendar || this.detail.calendar2) {
          this.detail.calendar.updateSize();
          if (this.hasMultipleMonths) {
            this.detail.calendar2.updateSize();
          }
        }
      })

      print_button.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.detail.calendar || this.detail.calendar2) {
          const accIsOpen = calendarAccordion.classList.contains('show');
          if (!accIsOpen) {
            calendarAccordion.classList.add('show')
          }
          this.detail.calendar.updateSize();
          if (this.hasMultipleMonths) {
            this.detail.calendar2.updateSize();
          }
          window.print();
          if (!accIsOpen) {
            calendarAccordion.classList.remove('show')
          }
        } else {
          window.print();
        }
      })

      await this.loadAllCourses();
      if (this.detail.allCourses.length < 1) {
        return;
      }

      let from = this.fromGlobal ? this.fromGlobal.clone() : null;
      let to = this.toGlobal ? this.toGlobal.clone() : null;

      this.registerCalendar(
        document.getElementById('calendar'),
        true,
        from ? from.format('YYYY-MM-DD') : null,
        from ? from.format('YYYY-MM-DD') : null,
        to ? (this.hasMultipleMonths ? to.clone().month(this.toGlobal.month() - 1).endOf('month').add(1, 'second') : to.add(1, 'second')).format('YYYY-MM-DD') : null
      );
      if (this.hasMultipleMonths) {

        from = this.fromGlobal ? this.fromGlobal.clone() : null;
        to = this.toGlobal ? this.toGlobal.clone() : null;

        this.registerCalendar(
          document.getElementById('calendar2'),
          false,
          from ? from.clone().month(this.fromGlobal.month() + 1).startOf('month').format('YYYY-MM-DD') : null,
          from ? from.clone().month(this.fromGlobal.month() + 1).startOf('month').format('YYYY-MM-DD') : null,
          to ? to.clone().add(1, 'second').format('YYYY-MM-DD') : null
        );

        document.querySelector('#calendar-separator').style.opacity = '1';
      }

      this.setEvents();
      this.updateEvents();
      this.updateMonth();
      document.querySelector('#calendar-course-number').style.display = 'block';
      // document.dispatchEvent(new CustomEvent("course-page-calendar-loaded"));
    },

    registerCalendar(htmlElm, isFirstCalendar, initialDate, validStart, validEnd) {

      let calendar = new Calendar(htmlElm, {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        locale: deLocale,
        initialDate: initialDate,
        showNonCurrentDates: false,
        validRange: {
          start: validStart,
          end: validEnd,
        },
        headerToolbar: {
          left: '',
          center: '',
          right: ''
        },
      });
      if (isFirstCalendar) {
        this.detail.calendar = calendar;
        this.detail.calendar.render();
      } else {
        this.detail.calendar2 = calendar;
        this.detail.calendar2.render();
      }
    },

    async loadAllCourses() {
      let allCourses = [];
      let courses = await events.getKursTermine(this.kursnr);
      allCourses.push(...(courses) ? this.addTagAndMapEntries(courses) : []);

      allCourses.forEach(course => {
        if (course.veranstvonz && course.veranstvonz !== "") {
          let from = moment(course.veranstvonz, 'YYYY-MM-DDTHH:mm');
          if (this.fromGlobal == null || from.isBefore(this.fromGlobal)) {
            this.fromGlobal = from.startOf('month');
          }
        }
        if (course.veranstbisz && course.veranstbisz !== "") {
          let to = moment(course.veranstbisz, 'YYYY-MM-DDTHH:mm');
          if (this.toGlobal == null || to.isAfter(this.toGlobal)) {
            this.toGlobal = to.endOf('month');
          }
        }
      })

      if (this.fromGlobal !== null && this.toGlobal !== null && this.fromGlobal?.month() == this.toGlobal?.month()) {
        this.hasMultipleMonths = false;
      } else {
        this.hasMultipleMonths = true;
      }

      for (let i = 0; i < allCourses.length; i++) {
        let course = allCourses[i];
        this.detail.courses[course.kurs.kursnr] = course.kurs.kursbez;
        this.detail.subjects[course.unterrichtsfach.fachnr] = course.unterrichtsfach.fachbez;
      }
      this.detail.allCourses = allCourses;
    },
    addTagAndMapEntries(entries) {
      for (let i = 0; i < entries.length; i++) {
        entries[i].location = this.getLocationMapping(entries[i]);
      }
      return entries;
    },
    getLocationMapping(entry) {
      return 'on-site';
    },
    setEvents() {
      for (let i = 0; i < this.detail.allCourses.length; i++) {
        let course = this.detail.allCourses[i];
        let from = moment(course.veranstvonz);
        let to = moment(course.veranstbisz);
        this.detail.calendar.addEvent({
          title: 'MyEvent',
          start: from.toDate(),
          end: to.toDate(),
          allDay: true,
          className: 'event_color--' + this.getLocationMapping(course)
        })
        if (this.hasMultipleMonths) {
          this.detail.calendar2.addEvent({
            title: 'MyEvent',
            start: from.toDate(),
            end: to.toDate(),
            allDay: true,
            className: 'event_color--' + this.getLocationMapping(course)
          })
        }
      }

    },
    updateEvents() {
      let elements = document.getElementsByClassName('fc-daygrid-event');
      for (let i = 0; i < elements.length; i++) {
        let element = elements[i];
        let classes = element.classList;
        let day = element.parentElement.parentElement.previousSibling;
        day.classList.remove(...day.classList);
        day.classList.add('fc-daygrid-day-top');
        day.classList.add(classes[classes.length - 1]);
      }

      document.querySelectorAll('.fc').forEach(calendar => {
        addDateEventListeners(calendar, 'internal__event__detail__overlay', this.detail.allCourses, true);
      });
    },
    nextDetailCalendar: function () {
      this.detail.calendar.next();
      if (this.hasMultipleMonths) {
        this.detail.calendar2.next();
      }
      this.updateMonth();
      this.updateEvents();
    },
    prevDetailCalendar: function () {
      this.detail.calendar.prev();
      if (this.hasMultipleMonths) {
        this.detail.calendar2.prev();
      }
      this.updateMonth();
      this.updateEvents();
    },
    resetDetailCalendar: function () {
      this.detail.calendar.today();
      if (this.hasMultipleMonths) {
        this.detail.calendar2.today();
      }
      this.updateMonth();
      this.updateEvents();
    },
    updateMonth() {
      moment.locale('de');
      this.detail.month = moment(this.detail.calendar.getDate().toISOString()).format('MMMM Y');
      if (this.hasMultipleMonths) {
        this.detail.month2 = moment(this.detail.calendar2.getDate().toISOString()).format('MMMM Y');
      }
    },
    getCourseTitle(course) {
      if (course) {
        moment.locale('de');
        let from = moment(course.veranstvonz);
        let to = moment(course.veranstbisz);
        return from.format('dd. DD.MM.YYYY, HH:mm') + ' bis ' + to.format('HH:mm');
      }
    },
  };
};

if (!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.productPageCalendar = alpineData;
